"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 全角数字
 *
 * [０１２３４５６７８９]
 *
 */
exports.FULLWIDTH_DIGIT_CHARS = "\uFF10-\uFF19";